<template>
    <div class="min-h-screen bg-gray-50 p-6" v-loading="loading">
      <div class="mx-auto max-w-7xl bg-white rounded-lg shadow-sm">
        <div class="flex min-h-[800px]">
          <!-- 左侧商品列表 -->
          <div class="w-3/5 border-r border-gray-100 p-6">
    <div class="flex items-center mb-6">
      <div class="relative flex-1">
        <input
          type="text"
          placeholder="搜索商品"
          v-model="searchForm.keyword"
          class="w-full pl-10 pr-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
      </div>
    </div>
    <div class="grid grid-cols-5 gap-4">
      <div
        v-for="(product, index) in products"
        :key="product.id"
        :class="{'border-blue-500': product.flag}"
        class="relative border rounded-lg p-8 cursor-pointer hover:shadow-md transition-shadow"
        @click.stop="handleProductClick(index)"
      >

      <div class="absolute left-2 top-2 z-10 flex items-center">
    <!-- 复选框容器 -->
    <div class="relative">
      <input
        type="checkbox"
        :checked="product.flag"
        @click.stop="toggleProduct(index)"
        class="opacity-0 absolute inset-0 w-full h-full cursor-pointer"
      >
      <!-- 自定义复选框 -->
      <div class="w-4 h-4 border-2 border-gray-300 rounded-sm transition-colors duration-150"></div>

      <!-- 集成勾选图标 -->
      <div
        class="absolute -inset-1 flex items-center justify-center pointer-events-none"
        :class="{'opacity-0': !selectedProducts.includes(index)}"
      >
        <svg
          class="w-5 h-5 text-blue-500 transition-opacity duration-200"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
    </div>
  </div>



          <!-- 上方标注 -->
          <div class="absolute -top-6 left-3 -translate-x-1/3 flex items-center">
            <i class="fas fa-arrow-right mx-2 text-gray-400"></i>
            <span class="text-gray-500 text-sm">{{ width }}cm</span>
            <i class="fas fa-arrow-left mx-2 text-gray-400"></i>
          </div>

          <!-- 左侧标注 -->
          <div class="absolute -left-4 top-2 -translate-y-1/3 flex flex-col items-center">
            <i class="fas fa-arrow-down my-2 text-gray-400"></i>
            <span class="text-gray-500 text-sm writing-mode-vertical">{{ height }}cm</span>
            <i class="fas fa-arrow-up my-2 text-gray-400"></i>
          </div>

          <!-- 图片 -->
          <div class="aspect-w-1 aspect-h-1 overflow-hidden rounded-lg">
            <img :src="product.image" :alt="product.name" class="w-full h-full object-cover" />
          </div>

          <div class="absolute -right-2 -top-2">
            <i v-if="selectedProducts.includes(index)"
               class="fas fa-check-circle text-blue-500 text-xl"></i>
          </div>
        </div>
      </div>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>


    </div>

          <!-- 右侧属性配置 -->
          <div class="w-2/5 p-6" v-if="products[hindex] && products[hindex].flag">
            <div class="mb-6">
              <h2 class="text-lg font-medium mb-4">已选择 {{ selectedProducts.length }} 个商品</h2>
            </div>
            <div class="space-y-6" v-if="hindex >= 0 && products[hindex].subcategerys">
              <!-- 选择产品子类型 -->
              <div class="border-b pb-6">
                <h3 class="text-sm font-medium mb-4">选择产品子类型（单选）</h3>
                <div class="flex gap-4">
                  <button
                    v-for="(item,index) in  products[hindex].subcategerys"
                    :key="index"
                    :class="{
                      'bg-blue-50 text-blue-600 border-blue-200': item.flag ,
                      'bg-gray-50 text-gray-600 border-gray-200':!item.flag
                    }"
                    class="px-4 py-2 border rounded-lg text-sm !rounded-button whitespace-nowrap"
                     @click="handleTypeSelect(index)"
                  >
                    {{ item.name }}
                  </button>
                </div>
              </div>
              <!-- <div  v-if="products[hindex].subcategerys[products[hindex].index].assessList">
                <div
                class="container"
                v-for="(itemA,indexA) in products[hindex].subcategerys[products[hindex].index].assessList"
                :key="itemA.uid"
                style="margin-bottom: 24px; border-bottom: 1px dashed #eee; padding: 24px;"
  >
                  <div class="switch-container" >
                    <div class="info-label">
                      <span>特殊工艺(线条字)</span>
                      <label class="switch">
                        <input
                        type="checkbox"
                        :checked="itemA.is_special === 1"
                        @change="handleSwitchChange($event, indexA)"
                        >
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                  <div class="size-input-area">
                    <div
                    class="input-group"
                    v-if="itemA.is_special === 1"
                    style="margin-top: 19px;"
                    key="special-inputs"
                    >
                    <input
                    class="size-input"
                    type="number"
                    v-model.number="itemA.girth"
                    placeholder="周长"
                    >



                    <span class="multiply">×</span>
                    <input
                    class="size-input"
                    type="number"
                    v-model.number="itemA.thickness"
                    placeholder="厚度"
                    >

                    <span class="multiply">×</span>
                    <span>cm</span>

                    <button
                  class="control-btn"
                  @click.stop="decreaseQuantity(indexA)"
                  >-</button>
                  <input
                  class="quantity-input"
                  type="number"
                  v-model.number="itemA.num"
                  min="1"
                  >
                  <button
                  class="control-btn"
                  @click.stop="increaseQuantity(indexA)">+</button>
                  </div>
                  <div
                  class="input-group"
                  style="margin-top: 19px;"
                  v-else
                  key="normal-inputs"
                  >
                  <input
                  class="size-input"
                  type="number"
                  v-model.number="itemA.width"
                  placeholder="宽"
                  >

                  <span class="multiply">×</span>
                  <input
                  class="size-input"
                  type="number"
                  v-model.number="itemA.height"
                  placeholder="长"
                  >


                  <span class="multiply">×</span>
                  <input
                  class="size-input"
                  type="number"
                  v-model.number="itemA.thickness"
                  placeholder="厚度">


                  <div style="width: 200px;display: flex;">
                    <button
                  class="control-btn"
                  @click.stop="decreaseQuantity(indexA)"
                  >-</button>
                  <input
                  class="quantity-input"
                  type="number"
                  v-model.number="itemA.num"
                  min="1"
                  >
                  <button
                  class="control-btn"
                  @click.stop="increaseQuantity(indexA)">+</button>
                  </div>
                </div>

                <div class="size-input-area" style=" margin-top: 20rpx;"><div class="input-group" v-if="itemA.is_special == 1">


                  <select
        v-model="itemA.sizeindex_g"
        @change="(e) => sizeChange(e, indexA, 'sizeindex_g')"
        style="margin-left: 26rpx;"
      >
        <option
          v-for="(sizeItem, idx) in itemA.sizearr"
          :key="idx"
          :value="idx"
        >
          {{ sizeItem.size || 'cm' }}
        </option>
      </select>
      <span style="margin-left: 90rpx;" class="multiply">X</span>
      <select
        v-model="itemA.sizeindex_t"
        @change="(e) => sizeChange(e, indexA, 'sizeindex_t')"
        style="margin-left: 26rpx;"
      >
        <option
          v-for="(sizeItem, idx) in itemA.sizearr"
          :key="idx"
          :value="idx"
        >
          {{ sizeItem.size || 'cm' }}
        </option>
      </select>
    </div>

    <div class="input-group" v-if="itemA.is_special == 0">
      <select
        v-model="itemA.sizeindex_w"
        @change="(e) => sizeChange(e, indexA, 'sizeindex_w')"
        style="margin-left: 46rpx;"
      >
        <option
          v-for="(sizeItem, idx) in itemA.sizearr"
          :key="idx"
          :value="idx"
        >
          {{ sizeItem.size || 'cm' }}
        </option>
      </select>
      <span style="margin-left: 86rpx;" class="multiply">X</span>
      <select
        v-model="itemA.sizeindex_h"
        @change="(e) => sizeChange(e, indexA, 'sizeindex_h')"
        style="margin-left: 26rpx;"
      >
        <option
          v-for="(sizeItem, idx) in itemA.sizearr"
          :key="idx"
          :value="idx"
        >
          {{ sizeItem.size || 'cm' }}
        </option>
      </select>
      <span style="margin-left: 80rpx;" class="multiply">X</span>
      <select
        v-model="itemA.sizeindex_t"
        @change="(e) => sizeChange(e, indexA, 'sizeindex_t')"
        style="margin-left: 26rpx;"
      >
        <option
          v-for="(sizeItem, idx) in itemA.sizearr"
          :key="idx"
          :value="idx"
        >
          {{ sizeItem.size || 'cm' }}
        </option>
      </select>
    </div>
  </div>

  <div style="font-size: 26rpx;color: #747474;">
    如公式中无上述参数，不会参与计算；例如：公式没有添加厚度参数，则填写厚度也不会计算
  </div>
  <div style="font-size: 26rpx;color: #747474;">
    请确认每个尺寸的单位，错误的单位可能会导致错误的计算结果
  </div>
  <div style="font-size: 26rpx;color: #747474;">
    单位最终会换算成cm进行计算
  </div>



              </div>
              <div
                class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-blue-500 transition-colors"
                @click="openProductUpload(indexA)"
                style="margin-top: 19px;"
              >
                <input type="file" ref="fileInput" class="hidden" @change="handleFileUpload" accept="image/*" />

                <div v-if="!itemA.imageUrl" class="space-y-2">
                  <i class="fas fa-cloud-upload-alt text-3xl text-gray-400"></i>
                  <p class="text-sm text-gray-500">点击或拖拽上传图片</p>
                  <p class="text-xs text-gray-400">支持 jpg、png、cdr 格式</p>
                </div>
                <div v-else class="relative">
                  <img :src="itemA.imageUrl.file_path" alt="Uploaded image" class="max-h-40 mx-auto rounded" />
                  <button
                    class="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600 !rounded-button whitespace-nowrap"
                    @click.stop="removeImage"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>


              <div class="border-b pb-6"  style="margin-top: 19px;">
                <h3 class="text-sm font-medium mb-4">产品参数</h3>
                <div v-for="(itemB,indexB) in itemA.attr" :key="indexB">
                  <div>{{ itemB.name }}</div>
                  <div style="width: 100%;margin-top: 10px;">
                    <button
                    v-for="(itemC,indexC) in itemB.childs"
                    :key="indexC"
                    @click="toggleParam(indexA,indexB,indexC)"
                    style="float: left;
                    margin-right: 10px;
                    line-height: 30px;"
                    :class="{
                      'bg-blue-50 text-blue-600 border-blue-200': itemC.flag,
                      'bg-gray-50 text-gray-600 border-gray-200':! itemC.flag
                      }"
                      class="px-4 border rounded-lg text-sm !rounded-button whitespace-nowrap"
                      >
                      {{ itemC.name }}
                    </button>
                    <div style="clear: both;"></div>
                  </div>
                </div>
              </div>

              <div class="action-bar flex justify-end mt-2">
                <button
                v-if="products[hindex].subcategerys[products[hindex].index].assessList.length > 1 && indexA > 0"
                @click="removeSize(indexA)"
                class="remove-button text-red-500 hover:text-red-600 text-sm flex items-center">
                移除
              </button>
            </div>
            </div>

          </div>
          <div class="action-bar">
            <button
            @click="addNewSize"
            class="add-button"
            >
            <i class="fas fa-plus"></i> 新增尺寸
          </button>
        </div>
        <div class="text-sm text-gray-500 mt-4">
                  注：如公式中无上述参数，不会参与计算；例如：公式没有添加厚度参数，则填写厚度也不会计算
         </div> -->



         <div v-if="products[hindex].subcategerys[products[hindex].index].assessList">
  <div
    class="container"
    v-for="(itemA,indexA) in products[hindex].subcategerys[products[hindex].index].assessList"
    :key="itemA.uid"
    style="margin-bottom: 24px; border-bottom: 1px dashed #eee; padding: 24px;"
  >
    <!-- 特殊工艺 -->
    <div v-if="hindex >= 0 && products[hindex] &&
     products[hindex].index >= 0 &&
     products[hindex].subcategerys &&
     products[hindex].subcategerys.length > 0 &&
     products[hindex].subcategerys[products[hindex].index].flag &&
     (products[hindex].subcategerys[products[hindex].index].max_height > 0 &&
      products[hindex].subcategerys[products[hindex].index].max_width > 0)">

  <div class="container"
       v-for="(itemA,indexA) in products[hindex].subcategerys[products[hindex].index].assessList"
       :key="itemA.uid"
       style="margin-bottom: 24px; border-bottom: 1px dashed #eee; padding: 24px;">

    <!-- 特殊工艺部分 -->
    <div class="switch-container">
      <div class="info-label">
        <span>特殊工艺(线条字)</span>
        <label class="switch">
          <input
            type="checkbox"
            :checked="itemA.is_special === 1"
            @change="handleSwitchChange($event, indexA)"
          >
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <!-- 尺寸输入区域 -->
    <div class="size-input-area">
      <div v-if="itemA.is_special === 1" class="input-group" style="margin-top: 19px;">
        <input class="size-input" type="number" v-model.number="itemA.girth" placeholder="周长">
        <span class="multiply">×</span>
        <input class="size-input" type="number" v-model.number="itemA.thickness" placeholder="厚度">
        <span class="multiply">×</span>
        <span>cm</span>

        <button class="control-btn" @click.stop="decreaseQuantity(indexA)">-</button>
        <input class="quantity-input" type="number" v-model.number="itemA.num" min="1">
        <button class="control-btn" @click.stop="increaseQuantity(indexA)">+</button>
      </div>

      <div v-else class="input-group" style="margin-top: 19px;">
        <input class="size-input" type="number" v-model.number="itemA.width" placeholder="宽">
        <span class="multiply">×</span>
        <input class="size-input" type="number" v-model.number="itemA.height" placeholder="长">
        <span class="multiply">×</span>
        <input class="size-input" type="number" v-model.number="itemA.thickness" placeholder="厚度">

        <div style="width: 200px;display: flex;">
          <button class="control-btn" @click.stop="decreaseQuantity(indexA)">-</button>
          <input class="quantity-input" type="number" v-model.number="itemA.num" min="1">
          <button class="control-btn" @click.stop="increaseQuantity(indexA)">+</button>
        </div>
      </div>
    </div>

    <!-- 单位选择器 -->
    <div class="size-input-area" style="margin-top: 20rpx;">
      <div v-if="itemA.is_special == 1" class="input-group">
        <select v-model="itemA.sizeindex_g" @change="(e) => sizeChange(e, indexA, 'sizeindex_g')" style="margin-left: 26rpx;">
          <option v-for="(sizeItem, idx) in itemA.sizearr" :key="idx" :value="idx">
            {{ sizeItem.size || 'cm' }}
          </option>
        </select>
        <span style="margin-left: 90rpx;" class="multiply">X</span>
        <select v-model="itemA.sizeindex_t" @change="(e) => sizeChange(e, indexA, 'sizeindex_t')" style="margin-left: 26rpx;">
          <option v-for="(sizeItem, idx) in itemA.sizearr" :key="idx" :value="idx">
            {{ sizeItem.size || 'cm' }}
          </option>
        </select>
      </div>

      <div v-if="itemA.is_special == 0" class="input-group">
        <select v-model="itemA.sizeindex_w" @change="(e) => sizeChange(e, indexA, 'sizeindex_w')" style="margin-left: 46rpx;">
          <option v-for="(sizeItem, idx) in itemA.sizearr" :key="idx" :value="idx">
            {{ sizeItem.size || 'cm' }}
          </option>
        </select>
        <span style="margin-left: 86rpx;" class="multiply">X</span>
        <select v-model="itemA.sizeindex_h" @change="(e) => sizeChange(e, indexA, 'sizeindex_h')" style="margin-left: 26rpx;">
          <option v-for="(sizeItem, idx) in itemA.sizearr" :key="idx" :value="idx">
            {{ sizeItem.size || 'cm' }}
          </option>
        </select>
        <span style="margin-left: 80rpx;" class="multiply">X</span>
        <select v-model="itemA.sizeindex_t" @change="(e) => sizeChange(e, indexA, 'sizeindex_t')" style="margin-left: 26rpx;">
          <option v-for="(sizeItem, idx) in itemA.sizearr" :key="idx" :value="idx">
            {{ sizeItem.size || 'cm' }}
          </option>
        </select>
      </div>
    </div>

    <!-- 尺寸说明 -->
    <div style="font-size: 26rpx;color: #747474; margin-top: 10px;">
      <div>如公式中无上述参数，不会参与计算；例如：公式没有添加厚度参数，则填写厚度也不会计算</div>
      <div>请确认每个尺寸的单位，错误的单位可能会导致错误的计算结果</div>
      <div>单位最终会换算成cm进行计算</div>
    </div>

    <!-- 图片上传区域 -->
    <div class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-blue-500 transition-colors"
         style="margin-top: 19px;"
         @click="openProductUpload(indexA)">
      <input type="file" ref="fileInput" class="hidden" @change="handleFileUpload" accept="image/*">
      <div v-if="!itemA.imageUrl" class="space-y-2">
        <i class="fas fa-cloud-upload-alt text-3xl text-gray-400"></i>
        <p class="text-sm text-gray-500">点击或拖拽上传图片</p>
        <p class="text-xs text-gray-400">支持 jpg、png、cdr 格式</p>
      </div>
      <div v-else class="relative">
        <img :src="itemA.imageUrl.file_path" alt="Uploaded image" class="max-h-40 mx-auto rounded">
        <button class="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600 !rounded-button whitespace-nowrap"
                @click.stop="removeImage">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- 操作按钮 -->
    <div class="action-bar flex justify-end mt-2">
      <button v-if="products[hindex].subcategerys[products[hindex].index].assessList.length > 1 && indexA > 0"
              @click="removeSize(indexA)"
              class="remove-button text-red-500 hover:text-red-600 text-sm flex items-center">
        移除
      </button>
    </div>
  </div>

  <!-- 新增尺寸按钮 -->
  <div class="add-size" @click="addAssess" style="margin-top: 20px; text-align: center;">
    <button class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded">
      新增尺寸
    </button>
  </div>


    <!-- 尺寸输入区域（紧接特殊工艺） -->
    <!-- <div class="size-input-area">
      <div
        class="input-group"
        v-if="itemA.is_special === 1"
        style="margin-top: 19px;"
        key="special-inputs"
      >
        <input
          class="size-input"
          type="number"
          v-model.number="itemA.girth"
          placeholder="周长"
        >
        <span class="multiply">×</span>
        <input
          class="size-input"
          type="number"
          v-model.number="itemA.thickness"
          placeholder="厚度"
        >
        <span class="multiply">×</span>
        <span>cm</span>

        <button
          class="control-btn"
          @click.stop="decreaseQuantity(indexA)"
        >-</button>
        <input
          class="quantity-input"
          type="number"
          v-model.number="itemA.num"
          min="1"
        >
        <button
          class="control-btn"
          @click.stop="increaseQuantity(indexA)"
        >+</button>
      </div>

      <div
        class="input-group"
        style="margin-top: 19px;"
        v-else
        key="normal-inputs"
      >
        <input
          class="size-input"
          type="number"
          v-model.number="itemA.width"
          placeholder="宽"
        >
        <span class="multiply">×</span>
        <input
          class="size-input"
          type="number"
          v-model.number="itemA.height"
          placeholder="长"
        >
        <span class="multiply">×</span>
        <input
          class="size-input"
          type="number"
          v-model.number="itemA.thickness"
          placeholder="厚度"
        >
        <div style="width: 200px;display: flex;">
          <button
            class="control-btn"
            @click.stop="decreaseQuantity(indexA)"
          >-</button>
          <input
            class="quantity-input"
            type="number"
            v-model.number="itemA.num"
            min="1"
          >
          <button
            class="control-btn"
            @click.stop="increaseQuantity(indexA)"
          >+</button>
        </div>
      </div>
    </div> -->

    <!-- 尺寸单位选择 -->
    <!-- <div class="size-input-area" style="margin-top: 20rpx;">
      <div class="input-group" v-if="itemA.is_special == 1">
        <select
          v-model="itemA.sizeindex_g"
          @change="(e) => sizeChange(e, indexA, 'sizeindex_g')"
          style="margin-left: 26rpx;"
        >
          <option
            v-for="(sizeItem, idx) in itemA.sizearr"
            :key="idx"
            :value="idx"
          >
            {{ sizeItem.size || 'cm' }}
          </option>
        </select>
        <span style="margin-left: 90rpx;" class="multiply">X</span>
        <select
          v-model="itemA.sizeindex_t"
          @change="(e) => sizeChange(e, indexA, 'sizeindex_t')"
          style="margin-left: 26rpx;"
        >
          <option
            v-for="(sizeItem, idx) in itemA.sizearr"
            :key="idx"
            :value="idx"
          >
            {{ sizeItem.size || 'cm' }}
          </option>
        </select>
      </div>

      <div class="input-group" v-if="itemA.is_special == 0">
        <select
          v-model="itemA.sizeindex_w"
          @change="(e) => sizeChange(e, indexA, 'sizeindex_w')"
          style="margin-left: 46rpx;"
        >
          <option
            v-for="(sizeItem, idx) in itemA.sizearr"
            :key="idx"
            :value="idx"
          >
            {{ sizeItem.size || 'cm' }}
          </option>
        </select>
        <span style="margin-left: 86rpx;" class="multiply">X</span>
        <select
          v-model="itemA.sizeindex_h"
          @change="(e) => sizeChange(e, indexA, 'sizeindex_h')"
          style="margin-left: 26rpx;"
        >
          <option
            v-for="(sizeItem, idx) in itemA.sizearr"
            :key="idx"
            :value="idx"
          >
            {{ sizeItem.size || 'cm' }}
          </option>
        </select>
        <span style="margin-left: 80rpx;" class="multiply">X</span>
        <select
          v-model="itemA.sizeindex_t"
          @change="(e) => sizeChange(e, indexA, 'sizeindex_t')"
          style="margin-left: 26rpx;"
        >
          <option
            v-for="(sizeItem, idx) in itemA.sizearr"
            :key="idx"
            :value="idx"
          >
            {{ sizeItem.size || 'cm' }}
          </option>
        </select>
      </div>
    </div> -->

      <!-- 尺寸说明 -->
      <!-- <div style="font-size: 26rpx;color: #747474; margin-top: 10px;">
      <div>如公式中无上述参数，不会参与计算；例如：公式没有添加厚度参数，则填写厚度也不会计算</div>
      <div>请确认每个尺寸的单位，错误的单位可能会导致错误的计算结果</div>
      <div>单位最终会换算成cm进行计算</div>
    </div>-->


    <!-- 图片上传区域 -->
    <!-- <div
      class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-blue-500 transition-colors"
      @click="openProductUpload(indexA)"
      style="margin-top: 19px;"
    >
      <input type="file" ref="fileInput" class="hidden" @change="handleFileUpload" accept="image/*" />
      <div v-if="!itemA.imageUrl" class="space-y-2">
        <i class="fas fa-cloud-upload-alt text-3xl text-gray-400"></i>
        <p class="text-sm text-gray-500">点击或拖拽上传图片</p>
        <p class="text-xs text-gray-400">支持 jpg、png、cdr 格式</p>
      </div>
      <div v-else class="relative">
        <img :src="itemA.imageUrl.file_path" alt="Uploaded image" class="max-h-40 mx-auto rounded" />
        <button
          class="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600 !rounded-button whitespace-nowrap"
          @click.stop="removeImage"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div> -->
  </div>


    <!-- 产品参数 -->
    <div class="border-b pb-6" style="margin-top: 19px;">
      <h3 class="text-sm font-medium mb-4">产品参数</h3>
      <div v-for="(itemB,indexB) in itemA.attr" :key="indexB">
        <div>{{ itemB.name }}</div>
        <div style="width: 100%;margin-top: 10px;">
          <button
            v-for="(itemC,indexC) in itemB.childs"
            :key="indexC"
            @click="toggleParam(indexA,indexB,indexC)"
            style="float: left; margin-right: 10px; line-height: 30px;"
            :class="{
              'bg-blue-50 text-blue-600 border-blue-200': itemC.flag,
              'bg-gray-50 text-gray-600 border-gray-200': !itemC.flag
            }"
            class="px-4 border rounded-lg text-sm !rounded-button whitespace-nowrap"
          >
            {{ itemC.name }}
          </button>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>




    <!-- 操作按钮 -->
    <div class="action-bar flex justify-end mt-2">
      <button
        v-if="products[hindex].subcategerys[products[hindex].index].assessList.length > 1 && indexA > 0"
        @click="removeSize(indexA)"
        class="remove-button text-red-500 hover:text-red-600 text-sm flex items-center"
      >
        移除
      </button>
    </div>
  </div>
</div>


            </div>
          </div>
          <div class="w-1/3 p-6" v-else style="text-align: center;line-height: 100px;">请选择左边产品</div>
        </div>
      </div>

      <div class="common-button-wrapper" style="height: 100px;">

        <div >

                  <div>

                    <div class="space-y-6" >

                            <!-- 预估金额和按钮 -->
                          <div class="mt-6 space-y-4">
                            <button
                            @click="remove"
                            style="width: 100px;padding:10px; text-align: center;"
                            class="w-full py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors !rounded-button whitespace-nowrap">
                            移除选择产品
                            </button>


                            <button
                            @click="handleOrder"
                            v-if="showPrice===false"
                            style="width: 100px;padding:10px; text-align: center;"
                            class="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap">
                            获取估价
                            </button>
                            <button
                            @click="goBuy"
                            v-if="showPrice===true"
                              style="width: 100px;padding:10px;text-align: center;"
                            class="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap">
                            立即下单
                            </button>
                            <div style="height: 2dvh;width: 100%;"></div>
                        </div>


              </div>
          </div>
            </div>

            <div  style="float: right;margin-left: 100px;">
                <div v-if="showPrice === true" class="text-lg font-medium text-gray-800">
                预估金额：<span class="text-blue-600">¥{{order.quote_price }}</span>
                </div>
            </div>
            <div style="clear: both;"> </div>

      </div>

      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload"
            @returnImgs="returnProductImgsFunc">上传图片
        </Upload>
    </div>
  </template>

  <script>
  import Hproduct from '@/api/hproduct.js'
  import Upload from "@/components/file/Upload";
  import $ from 'jquery';
  import eventBus from '@/utils/event-bus';
  export default {
    components: {
            Upload,
        },
    data() {
      return {
        isProductUpload:false,
        uploadedImage: '',
        specialCraft: false,
        selectedParams: null,
        productParams: [],
        products: [],
        selectedProducts: [],
        productTypes: [],
        selectedType: 1,
        specialCraft: false,
        width: 1,
        height: 1,
        estimatedPrice:0,
        assessList : [],
        val:{},

        hindex:-1,
      // 列表项索引
      index: {
        type: Number,
        required: true
      },
      order:{},
      dialogVisible: false,
      showPrice:false,


      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm:{
        keyword:""
      },

      loading:false,
      order_id:0,

      };
    },

    created() {
      this.order_id = this.$route.query.order_id;
          this.getProduct()
    },
    watch:{
      'products': {
				handler(newVal, oldVal) {
					// this.showPrice = false
				},
				deep: true, // 深度监听
				immediate: true // 立即执行一次监听器的回调函数
			},
    },
    mounted() {
    eventBus.$on('city-changed', (city) => {
      console.log('收到城市变更:', city);
      this.getProduct();
    });
  },
  beforeDestroy() {
    eventBus.$off('city-changed'); // 避免内存泄漏
  },
    methods: {
      openProductUpload: function(indexA) {
    console.log(12312321312312,indexA)
    var hindex = this.hindex; //主产品的下标
    var sindex = this.products[hindex].index;
    this.products[hindex].subcategerys[sindex].index = indexA ; //尺寸的下标
    this.isProductUpload = true;
},
returnProductImgsFunc(e) {
    let self = this
    console.log('e',e)
    if(e.length > 1){
      self.$message({
        message: '每次只能选择一张',
        type: 'error'
      });
      return;
    }
    // 没选的情况
    if(e.length == 0){
      self.$message({
        message: '请先选择图片',
        type: 'error'
      });
      return;
    }

    var hindex = this.hindex; //主产品的下标
    var sindex = this.products[hindex].index;
    var aindex = this.products[hindex].subcategerys[sindex].index ; //尺寸的下标

    var path = e[0].file_path;

    self.products[hindex].subcategerys[sindex].assessList[aindex].imageUrl = {
							name: e[0].name, // 文件名称
							file_path:path, // 文件路径

						}
            this.isProductUpload = false;
            console.log('path',path)

     // 2. 显示加载
     var loadingInstance = this.$loading({
            lock: true,
            text: '正在识别图片尺寸...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });

    // $.ajax({
    //             url: 'https://ggpzp.sdyilian.top/api/upload/remote',
    //             method: "POST",
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //             data: JSON.stringify({ // 转成 JSON 字符串
    //                 url:path
    //             }),
    //             contentType: 'application/json', // 明确告诉服务器发送的是 JSON
    //             processData: false, // 禁止 jQuery 转换数据格式
    //             dataType: "json",
    //             success: function(data) {
    //               console.log('data',data)
    //               if(data.error == '无法识别尺寸'){
    //                 self.$message({
    //                   message: '无法识别尺寸',
    //                   type: 'error'
    //                 });

    //                 self.products[hindex].subcategerys[sindex].assessList[aindex].imageUrl = {
		// 					name: "", // 文件名称
		// 					file_path:"", // 文件路径

		// 				}
    //         loadingInstance.close()
    //                 return;
    //               }
    //               loadingInstance.close()
    //                 self.products[hindex].subcategerys[sindex].assessList[aindex].width =  data.width
    //                 self.products[hindex].subcategerys[sindex].assessList[aindex].height =  data.height
    //                 data.data.file_path = path
    //                 self.products[hindex].subcategerys[sindex].assessList[aindex].imageUrl = data.data

    //                 self.isloading = false
    //             },
    //             error: function(xhr, status, error) {
    //                 console.error("请求出错：", error);
    //             }
    //         });


    if (self.isImageFile(path)) {
    // 处理图片文件
    $.ajax({
        url: 'https://ggpzp.sdyilian.top/api/upload/remote',
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            url: path
        }),
        contentType: 'application/json',
        processData: false,
        dataType: "json",
        success: function(data) {
            console.log('data', data)
            if (data.error == '无法识别尺寸') {
                self.$message({
                    message: '无法识别尺寸',
                    type: 'error'
                });

                self.products[hindex].subcategerys[sindex].assessList[aindex].imageUrl = {
                    name: "",
                    file_path: "",
                }
                loadingInstance.close()
                return;
            }
            loadingInstance.close()
            self.products[hindex].subcategerys[sindex].assessList[aindex].width = data.width
            self.products[hindex].subcategerys[sindex].assessList[aindex].height = data.height
            data.data.file_path = path
            self.products[hindex].subcategerys[sindex].assessList[aindex].imageUrl = data.data

            self.isloading = false
        },
        error: function(xhr, status, error) {
            console.error("请求出错：", error);
        }
    });
} else {
  const fileInput = document.createElement('input');
    fileInput.type = 'file';

    fileInput.onchange = e => {
        const file = e.target.files[0];
        if (!file) return;

        let formData = new FormData();
        formData.append('file', file);  // 确保这里上传的是File对象而不是URL

        $.ajax({
            url: 'https://chzp24537603.vicp.fun/api/upload',
            method: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function(res) {
                const data = typeof res === 'string' ? JSON.parse(res) : res;
                console.log('data', data)
            if (data.error == '无法识别尺寸') {
                self.$message({
                    message: '无法识别尺寸',
                    type: 'error'
                });

                self.products[hindex].subcategerys[sindex].assessList[aindex].imageUrl = {
                    name: "",
                    file_path: "",
                }
                loadingInstance.close()
                return;
            }
            loadingInstance.close()
            self.products[hindex].subcategerys[sindex].assessList[aindex].width = data.width
            self.products[hindex].subcategerys[sindex].assessList[aindex].height = data.height
            data.data.file_path = path
            self.products[hindex].subcategerys[sindex].assessList[aindex].imageUrl = data.data

            self.isloading = false
            },
            error: function(xhr, status, error) {
                // 错误处理
            }
        });
    };

    // 触发文件选择
    fileInput.click();

}

},
isImageFile(filename) {
				const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
				const extension = filename.split('.').pop().toLowerCase();
				return imageExtensions.includes(extension);
			},
sizeChange(e, index, key) {

this.newProducts[this.hindex].subcategerys[this.newProducts[this.hindex].index].assessList[index][key]
= e.detail.value

},
    /*选择第几页*/
    handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.getProduct();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getProduct();
      },




      toggleParam(indexA,indexB,indexC) {
        var hindex = this.hindex; //主产品的下标
        var sindex = this.products[hindex].index;

        var aindex = this.products[hindex].subcategerys[sindex].index = indexA; //尺寸的下标
        this.products[hindex].subcategerys[sindex].assessList[aindex].attr[indexB].childs.forEach(element => {
            element.flag = false;
        });

        this.products[hindex].subcategerys[sindex].assessList[aindex].attr[indexB].childs[indexC].flag = true;
        localStorage.setItem('select_product',JSON.stringify(this.products))
      },
      triggerUpload() {
        console.log('上传图片')

        //this.$refs.fileInput.click();
      },

      increaseQuantity(index) {
    if (!this.products[this.hindex].subcategerys[this.products[this.hindex].index].assessList[index].num) {
      this.$set(this.products[this.hindex].subcategerys[this.products[this.hindex].index].assessList[index], 'num', 1)
    } else {
      this.products[this.hindex].subcategerys[this.products[this.hindex].index].assessList[index].num++
    }
  },
  decreaseQuantity(index) {
    if (this.products[this.hindex].subcategerys[this.products[this.hindex].index].assessList[index].num > 1) {
      this.products[this.hindex].subcategerys[this.products[this.hindex].index].assessList[index].num--
    }
  },
      handleFileUpload(event) {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.uploadedImage = e.target.result;
          };
          reader.readAsDataURL(file);
        }
      },
      removeImage() {
        this.uploadedImage = '';
        this.$refs.fileInput.value = '';
      },
      removeSize(indexA) {
    const hindex = this.hindex
    const sindex = this.products[hindex].index
    this.products[hindex].subcategerys[sindex].assessList.splice(indexA, 1)
  },
      handleClose() {
      console.log('弹窗已关闭')
    },
    handleConfirm() {
      this.dialogVisible = false
    },
       // 切换特殊工艺状态
       handleSwitchChange(event,index) {


        var hindex = this.hindex; //主产品的下标
        var sindex = this.products[hindex].index = index;

        this.products[hindex].subcategerys[sindex].index = index; //尺寸的下标


        this.products[hindex].subcategerys[sindex].assessList[index].is_special =
        this.products[hindex].subcategerys[sindex].assessList[index].is_special==1?0:1;

        localStorage.setItem('select_product',JSON.stringify(this.products))
      },


    addNewSize() {
    // 创建深拷贝模板
    const baseItem = {
      is_special: 0,
      uid: Date.now().toString(36) + Math.random().toString(36).substr(2), // 生成唯一ID
      width: null,
      height: null,
      thickness: null,
      girth: null,
      attr: JSON.parse(JSON.stringify(this.products[this.hindex].subcategerys[this.products[this.hindex].index].assessList[0].attr)) // 深拷贝属性
    };

    this.products[this.hindex].subcategerys[this.products[this.hindex].index].assessList.push(
      JSON.parse(JSON.stringify(baseItem))
    );

    localStorage.setItem('select_product',JSON.stringify(this.products))
  },
    handleTypeSelect(index){
      this.products[this.hindex].index = index

    this.products[this.hindex].subcategerys.forEach(element => {
        element.flag = false;
    });
      this.products[this.hindex].subcategerys[index].flag  = true;

      localStorage.setItem('select_product',JSON.stringify(this.products))

    },
    // 处理商品点击（获取ID）
    handleProductClick(index) {

    this.hindex = index;

    this.products[index].flag = true;

    localStorage.setItem('select_product',JSON.stringify(this.products))

    },
    toggleProduct(index) {
      this.products[index].flag = !this.products[index].flag
      if(this.products[index].flag){
        this.selectedProducts.push(this.products[index]);
      }else{
        let itindex = this.selectedProducts.findIndex(item=>item.hproduct_id==this.products[index].hproduct_id);
        this.selectedProducts.splice(itindex,1);
      }
      this.hindex = index
      localStorage.setItem('select_product',JSON.stringify(this.products))

      this.$forceUpdate()
    },
    remove(){
      var self = this;
      localStorage.removeItem("select_product")
      self.products = [];
      self.getProduct();

      self.$message({
        message: '选择的所有产品已移除',
        type: 'error'
      });
    },

      getProduct() {
        var self = this;
        var Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;

        const cachedData = localStorage.getItem('userCity');
        const usercity = JSON.parse(cachedData);
        const cityCode = usercity.cityCode;

        if(cityCode === undefined){
          Params.cityCode = usercity.data.cityCode
        }else{
          Params.cityCode = cityCode;
        }

        // 从缓存中获取产品数据
        let cachedProducts = JSON.parse(localStorage.getItem('select_product')) || [];
        console.log('cachedProducts',cachedProducts)
        if(cachedProducts.length > 0 ){
          if(self.products.length > 0){
            localStorage.setItem('select_product',JSON.stringify(self.products))
          }

          Hproduct.listx(Params, true).then((res) => {
          if (res.code == 1) {
            let newProducts = res.data.data;

                // 对比缓存数据和接口返回的数据
                newProducts.forEach((newProduct) => {

                  // 查找缓存中对应的产品
                  let cachedProduct = cachedProducts.find((item) => item.hproduct_id === newProduct.hproduct_id);
                  if (cachedProduct) {
                    newProduct.flag = cachedProduct.flag;
                    // 对比子分类
                    newProduct.subcategerys.forEach((newSubcategory) => {
                      let cachedSubcategory = cachedProduct.subcategerys.find(
                        (item) => item.hproduct_subcategory_id === newSubcategory.hproduct_subcategory_id
                      );
                      if (cachedSubcategory) {
                        newSubcategory.flag = cachedSubcategory.flag;
                        // 对比评估项
                        newSubcategory.assessList = cachedSubcategory.assessList;
                      }
                    });
                  }
                });

            // 更新页面数据
            console.log(newProducts,'newProducts');
            self.products = newProducts;
            self.totalDataNumber = res.data.total;

            // 调用其他逻辑
          // this.handleTypeSelect(0);
          }
        });
        }else{
          Hproduct.listx(Params,true).then((res) => {
            if(res.code == 1){
              self.products = res.data.data
              self.totalDataNumber = res.data.total
            //  this.handleTypeSelect(0)
            }
          })
        }

    },
      incrementWidth() {
        this.width++;
      },
      decrementWidth() {
        if (this.width > 1) this.width--;
      },
      incrementHeight() {
        this.height++;
      },
      decrementHeight() {
        if (this.height > 1) this.height--;
      },
      goBuy(){
        var self = this;
        self.loading = true;
        var params = self.order;
        var nhproduct = []
        var products = self.products;
        for (var i = 0; i < products.length; i++) {
          var el_i =products[i];
          if (el_i.flag) {
            var nsubcategerys = [];
            for (var j = 0; j < el_i.subcategerys.length; j++) {
              if (el_i.subcategerys[j].flag) {
                nsubcategerys.push(el_i.subcategerys[j])
              }
            }
						el_i.subcategerys = nsubcategerys;
						nhproduct.push(el_i);
					}
				}
				params.hproduct = nhproduct;
        Hproduct.createOrder({
          params:JSON.stringify(params),
          order_id:self.order_id
        }).then((res) => {
          self.loading = false;
          if(res.code == 1){
            self.$router.push({
              path: '/store/placeorder/order',
              query: {
                order_id: res.data
              }
            })
          }

    })

      },

      handleParamSelect(selectedParam) {
    const val = {
      fval: selectedParam.name,      // 例如 "电源一"
      category_id: selectedParam.category_id,
      parent_id: selectedParam.parent_id,
      price: selectedParam.price,    // 必须 > 0
      flag: true                     // 确保启用状态
    };
    this.val = val;
  },
  handleOrder() {
    var self = this;
	  var par = self.products;
    self.showPrice = true;
		var nhproduct = []
		for (var i = 0; i < par.length; i++) {
      var el_i =par[i];
			if (el_i.flag) {
				var nsubcategerys = [];
				for (var j = 0; j < el_i.subcategerys.length; j++) {
          console.log("el_i.subcategerys[j].flag",el_i.subcategerys[j].flag);

					if (el_i.subcategerys[j].flag) {
						nsubcategerys.push(el_i.subcategerys[j])
					}
				}
				el_i.subcategerys = nsubcategerys;
				nhproduct.push(el_i);
					}
				}

    Hproduct.getQuotex({
      hproduct: JSON.stringify(nhproduct),
    }).then((res) => {
      console.log(res);
      self.order = res.data;
      self.$forceUpdate();
    })
    },
  },
  };
  </script>

  <style scoped>
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  .writing-mode-vertical {
    writing-mode: vertical-rl;
    text-orientation: mixed;
  }
  .custom-checkbox {
    @apply border-gray-300 bg-white;
    transition: all 0.2s ease;
  }

  input:checked ~ .custom-checkbox {
    @apply border-blue-500 bg-blue-500;
  }

  /* 勾选动画 */
  .custom-checkmark {
    @apply relative w-6 h-6 pointer-events-none;
    opacity: 0;
    transform: scale(0.8);
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  }

  .checked.custom-checkmark {
    opacity: 1;
    transform: scale(1);
  }

  /* 对勾绘制 */
  .checkmark-stem {
    @apply absolute bg-blue-500;
    width: 2px;
    height: 12px;
    left: 11px;
    top: 6px;
    transform: rotate(45deg);
  }

  .checkmark-kick {
    @apply absolute bg-blue-500;
    width: 2px;
    height: 6px;
    left: 7px;
    top: 12px;
    transform: rotate(-45deg);
  }

  /* 悬停交互效果 */
  .custom-checkbox:hover {
    @apply border-blue-300;
  }
  /* 联合动画效果 */
  .relative:hover .border-gray-300 {
    border-color: #93c5fd;
  }

  input:checked ~ div:last-child {
    opacity: 1 !important;
  }

  input:checked ~ div:first-child {
    border-color: #3b82f6;
    background-color: rgba(59, 130, 246, 0.1);
  }

  /* 自定义入场动画 */
  .absolute.-inset-1 {
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  }

  /* 优化SVG对齐 */

  input:focus ~ .custom-checkbox {
    @apply ring-2 ring-blue-200;
  }

  svg {
    margin-left: -2px;
    margin-top: -1px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 24px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .quantity-control {
  display: flex;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
}

.control-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

.control-btn:hover {
  background: #e5e7eb;
}

.quantity-input {
  width: 50px;
  text-align: center;
  border: none;
  background: transparent;
  -moz-appearance: textfield;
}

/* 隐藏数字输入框的箭头 */
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #5ebaeb;
  }

  input:checked + .slider:before {
    transform: translateX(24px);
  }

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  /* 尺寸输入区域 */
  .size-input-area {
    margin-top: 20rpx;
  }

  .input-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .size-input {
    width: 100px;
    padding: 6px 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  .quantity-control {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
  }

  .control-btn {
    padding: 4px 12px;
    border: 1px solid #666;
    border-radius: 4px;
    background: none;
    cursor: pointer;
  }
  .container {
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  transition: box-shadow 0.3s ease;
}

.container:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.size-input {
  @apply w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-blue-400 focus:border-blue-400;
}

.multiply {
  @apply text-gray-500 mx-1;
}

.quantity-control {
  @apply border-gray-300 overflow-hidden;
}

.quantity-input {
  -moz-appearance: textfield;
}
.remove-button {
  height: 30px;
  color: #f00;
  margin-right: 10px;
  line-height: 25px;
  float: right;
  font-size: 15px;
}
.add-button {
  width: 100%;
  margin: 0 auto;
  color: rgba(37, 99, 235);
}
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
  .formula-tip {
    font-size: 13px;
    color: #747474;
    margin-top: 12px;
  }
  </style>



// WEBPACK FOOTER //
// src/views/store/placeorder/index.vue